import { ExternalEntityStatus } from '@40seas/entities/external-entities';
import { EnumColor } from '@40seas/frontend/common/providers';

export const externalEntityStatusMapping = {
    [ExternalEntityStatus.Pending]: 'default',
    [ExternalEntityStatus.Succeeded]: 'success',
    [ExternalEntityStatus.PartiallySucceeded]: 'warning',
    [ExternalEntityStatus.Filtered]: 'warning',
    [ExternalEntityStatus.Failed]: 'error',
    [ExternalEntityStatus.InProgress]: 'info',
    [ExternalEntityStatus.Blocked]: 'info',
} as { [key in ExternalEntityStatus]: EnumColor };
